import { render } from "./FilterWithSearch.vue?vue&type=template&id=1289cb20"
import script from "./FilterWithSearch.vue?vue&type=script&lang=js"
export * from "./FilterWithSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__